import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { fetchItems, sendStatistic } from '@/api/faqs'
import useCrudStore from '@/hooks/useCrudStore'

export const useFaqsStore = defineStore('faqs', () => {
  const { currentItems, listLoading, FetchItems, SetFilters } = useCrudStore({
    fetchItems
  })

  const SendStat = async ({
    id = '',
    page = '',
    hit = false,
    event = false
  }: {
    id?: string
    page?: string
    hit?: boolean
    event?: boolean
  }) => {
    return sendStatistic(id, page, hit, event)
  }

  return {
    // State
    currentItems,
    listLoading,

    // Actions
    FetchItems,
    SetFilters,
    SendStat
  }
})
